import gql from 'graphql-tag';
import {
  TemperatureCriticalIcon,
  TemperatureNormalIcon,
  TemperatureWarningIcon,
} from '~components/ui/icons';
import { IconBadge, Props as IconBadgeProps } from '~components/ui/icons/IconBadge';
import { TemperatureBadge_DisplayFragment } from './__generated__/TemperatureBadge.graphql';
import { getTemperatureStatus } from './utils';

export default function TemperatureBadge({
  display,
  variant,
}: {
  display: TemperatureBadge_DisplayFragment;
} & Pick<IconBadgeProps, 'variant'>) {
  const { isCritical, isWarning } = getTemperatureStatus(display);

  if (isCritical) {
    return (
      <IconBadge
        bg="red.50"
        color="red.400"
        icon={TemperatureCriticalIcon}
        tooltip={undefined}
        variant={variant}
      />
    );
  } else if (isWarning) {
    return (
      <IconBadge
        bg="orange.50"
        color="orange.400"
        icon={TemperatureWarningIcon}
        tooltip={undefined}
        variant={variant}
      />
    );
  } else {
    return (
      <IconBadge
        bg="green.50"
        color="green.400"
        icon={TemperatureNormalIcon}
        tooltip={undefined}
        variant={variant}
      />
    );
  }
}

TemperatureBadge.graphql = {
  fragments: {
    TemperatureBadge_display: gql`
      fragment TemperatureBadge_display on Display {
        id
        temperatureThreshold {
          maxWarning
          max
        }
        temperatures {
          sensorId
          isSensorPresent
          value
          degrees
          unit
        }
        temperatureUpdatedAt
      }
    `,
  },
};
